export default "__VITE_ASSET__DWwUOPzc__"